import { HttpApiService } from "@/shared/services/httpApi.service";

import type {
  CreatePaymentTaxPayload,
  ListPaymentTaxesParams,
  PaymentTax,
} from "../types/paymentTaxes.types";
import { PAYMENTS_CONFIG_MAX_LIMIT, type PaginatedResponse, toQuery } from "./paymentsConfig.http";

const TAXES_URL = "/internal/payments/taxes";

export const PaymentTaxesService = {
  async list(params: ListPaymentTaxesParams = {}): Promise<PaginatedResponse<PaymentTax>> {
    const { data } = await HttpApiService.get<PaginatedResponse<PaymentTax>>(
      `${TAXES_URL}${toQuery({ ...params })}`,
    );
    return data;
  },

  /** Every version, so the resolver on screen sees what the backend sees. */
  async listAll(maxPages = 10): Promise<{ rows: PaymentTax[]; truncated: boolean }> {
    const rows: PaymentTax[] = [];
    let skip = 0;
    for (let page = 0; page < maxPages; page += 1) {
      const response = await PaymentTaxesService.list({ skip, limit: PAYMENTS_CONFIG_MAX_LIMIT });
      rows.push(...response.data);
      if (!response.hasMore || response.data.length === 0) return { rows, truncated: false };
      skip += PAYMENTS_CONFIG_MAX_LIMIT;
    }
    return { rows, truncated: true };
  },

  async create(payload: CreatePaymentTaxPayload): Promise<PaymentTax> {
    const { data } = await HttpApiService.post<PaymentTax, CreatePaymentTaxPayload>(TAXES_URL, payload);
    return data;
  },

  async remove(id: string): Promise<void> {
    await HttpApiService.delete(`${TAXES_URL}/${id}`);
  },
};
